import React from "react"

const GeneratedForm = () => {
  return (
    <div className="w-max-600px h-650px bg-white mt-20 p-20px">
      <h1 className="color-black">Consulting Agreement</h1>
      <p className="color-black ">
        The Consulting Agreement (the "Agreement" or "Consulting Agreement")
        states the terms and conditions that govern the contractual between
        <span className="bg-yellow">Libido AD</span> having its principal place
        of business at{" "}
        <span className="bg-yellow">
          Kunhstensgatan 23,114,23 Stockholm, Sweden
        </span>
        (the "Consultant"), and Paperwork AB (the "Client") who agrees to be
        bound by this Agreement.
        <br />
        <br />
        NOW, THEREFORE, In consideration on the manual covenants and promises
        made by the parties hereto, the Consultant and the Client (invidualy,
        each a "Party" and collectively, the "Parties") covenant and agree as
        follows:
        <br />
        <br />
        1.Term
        <br />
        This Agreement shall beign on{" "}
        <span className="bg-yellow">25/04/2021</span> and end on{" "}
        <span className="bg-yellow">14/05/2021</span>. Either Party may
        terminate this Agreement for any reason witn 30 days written notice to
        the other Party.
        <br />
        2.Consulting Services The Consultant agrees that it shall provide its
        expertise to the Client for all thingspertaining to{" "}
        <span className="bg-yellow">sound design of a new app</span>
        (the "Consulting Services").
        <br />
        <br />
        3.Compensation In consideration for the Consulting Services, the Client
        shall pay the Consultant at rate of{" "}
        <span className="bg-yellow">$100 per hour</span>. The Consultant shall
        invoice the Client once every 30 days and such invoices shall be due and
        payable within 60 days of the Client's receipt of the invoice.
        <br />
        <br />
        4. Intellectual Property Rights in Work Product The Parties acknowledge
        and agree that the Client will hold all intellectual property rights in
        any work product resulting from the Consulting Services including, but
        not limited to, copyrightand trademark rights. The Consultant agrees not
        to claim any such ownership in such work product's intellectual.
        property at any tiome prior to or after the completion and delivery of
        such work.
      </p>
    </div>
  )
}

export default GeneratedForm
